import { render, staticRenderFns } from "./OfficeStampNewPage.vue?vue&type=template&id=e40e5260&"
import script from "./OfficeStampNewPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeStampNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports